import { render, staticRenderFns } from "./RestaurantReviewsWidgetSection.vue?vue&type=template&id=0b168618&scoped=true&"
import script from "./RestaurantReviewsWidgetSection.vue?vue&type=script&lang=js&"
export * from "./RestaurantReviewsWidgetSection.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantReviewsWidgetSection.vue?vue&type=style&index=0&id=0b168618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b168618",
  null
  
)

export default component.exports